import { sectionRenderer } from "@theme/section-renderer";

document.addEventListener(
  "doofinder.hide",
  function (e) {
    // Stop the original event from propagating to prevent that Doofinder refreshes the page after adding a product to the cart
    e.stopImmediatePropagation();
  },
  true,
);

document.addEventListener("doofinder.show", function (e) {
  const sourceInput = document.querySelector(
    'input[type="search"][name="search[query]"]',
  );

  const targetForm = document.querySelector('form[action*="search"]');

  const targetInput = targetForm?.querySelector('input[name="q"]');

  if (!sourceInput || !targetForm || !targetInput) {
    return;
  }
  // When the user presses Enter in the Doofinder search input, copy the value to the original search input and submit the form to trigger the search results page
  sourceInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();

      targetInput.value = sourceInput.value;

      targetForm.submit();
    }
  });
});

document.addEventListener(
  "doofinder.cart.add",
  function (e) {
    // Override the original resolve and reject functions of the statusPromise to render the cart drawer section after a product is added to the cart
    const originalResolve = e.detail.statusPromise.resolve;

    const searchClosed = document.querySelector(".dfd-root[hidden]");
    // if search is closed, open sidecart drawer, otherwise do nothing (keep search open)
    // (probably the user added to cart from the reccomendations)
    if (searchClosed) {
      //open sidecart drawer with shimmer effect and 300ms delay to do not show too much loading time if the drawer opens very fast
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("sidecart:open"));
      }, 300);
    }

    e.detail.statusPromise.resolve = function (...args) {
      const sectionId = "cart-drawer";
      sectionRenderer.renderSection(sectionId, { cache: false });
      return originalResolve.apply(this, args);
    };

    const originalReject = e.detail.statusPromise.reject;

    e.detail.statusPromise.reject = function (...args) {
      return originalReject.apply(this, args);
    };
  },
  true,
);

const MAX_CATEGORIES = 3;
const MAX_WINERIES = 6;
const GRID_SELECTOR = '.dfd-results-grid[id*="collection"]';

const fastHash = (s) => {
  let h = 5381,
    i = s.length;
  while (i) h = (h * 33) ^ s.charCodeAt(--i);
  return (h >>> 0).toString(36);
};

const reorderGrid = () => {
  //console.log("Reordering grids...");
  document.querySelectorAll(GRID_SELECTOR).forEach((grid) => {
    const wrappers = [...grid.querySelectorAll('[id*="results_collection_"]')];
    if (!wrappers.length) {
      return;
    }

    const fp = fastHash(
      wrappers.map((w) => w.id || w.dataset.phxId || "").join("|"),
    );
    if (grid.dataset.fp === fp) {
      return;
    }
    grid.dataset.fp = fp;

    grid
      .querySelectorAll(".dfd-custom-section-header")
      .forEach((e) => e.remove());

    const categories = [],
      wineries = [];

    wrappers.forEach((w) => {
      const entity = w.querySelector("a.dfd-collection-item")?.dataset.entity;
      if (!entity) {
        return;
      }
      (entity === "winery" ? wineries : categories).push(w);
    });

    [
      ...categories.slice(0, MAX_CATEGORIES),
      ...wineries.slice(0, MAX_WINERIES),
    ].forEach((w) => (w.style.display = "block"));

    const addHeader = (list, text) => {
      if (!list.length) {
        return;
      }
      const h = document.createElement("div");
      h.className = "dfd-custom-section-header";
      h.textContent = text;
      h.style.display = "block";
      grid.insertBefore(h, list[0]);
    };

    addHeader(categories, "Collezioni");
    addHeader(wineries, "Cantine");
  });
};

// TODO: find a better way to trigger this on demand instead of polling every 200ms
// (for example, listen to a custom event that the DFD script can dispatch after it updates the grid,
// or use a MutationObserver to watch for changes in the grid and trigger the reorder only when it changes)
// const observer = new MutationObserver(reorderGrid);
// observer.observe(document, { childList: true, subtree: true });

setInterval(reorderGrid, 200);
